module.exports = __webpack_public_path__ + "static/media/Rank Table.8a3bc31a.png";